import React from 'react'

import { V1RequestStatus } from '@/lib/api/lib/models'
import type { V1ProgrammeRequest } from '@/lib/api/lib/models'

import { AppContext } from '@/components/base/appcontext'
import LinkWithState from '@/components/base/link'
import { statusConfig } from '@/components/requests/statusConfig'
import { Typography } from '@/components/ui/typography'
import { Badge } from '@/components/ui/badge'

import { ChevronRight, Send } from 'lucide-react'

function UserRequests({ requests }: { requests: V1ProgrammeRequest[] }) {
    const appContext = React.useContext(AppContext)

    const active = requests.filter(
        (r) => r.status !== V1RequestStatus.Abandoned
    )

    if (active.length === 0) return null

    const grouped = active.reduce<Record<string, number>>((acc, r) => {
        const s = r.status as string
        acc[s] = (acc[s] || 0) + 1
        return acc
    }, {})

    return (
        <LinkWithState to="/requests/list" className="block">
            <div className="req-animate-in flex items-center gap-3 p-3 rounded-xl bg-secondary/40 dark:bg-secondary/60 border border-border/40 coach-card-hover">
                <div className="h-9 w-9 rounded-lg bg-emerald-500/10 dark:bg-emerald-500/12 flex items-center justify-center shrink-0">
                    <Send className="h-4 w-4 text-emerald-600 dark:text-emerald-400" />
                </div>

                <div className="flex-1 min-w-0">
                    <Typography
                        variant="body-sm"
                        className="font-medium text-foreground"
                    >
                        {appContext.geti18n('requests.tab.sent')}
                    </Typography>
                    <div className="flex items-center gap-1.5 mt-0.5 flex-wrap">
                        {Object.entries(grouped).map(([status, count]) => {
                            const cfg = statusConfig[status]
                            return (
                                <Badge
                                    key={status}
                                    variant="secondary"
                                    className={`text-[0.6rem] px-1.5 py-0 leading-relaxed ${cfg?.color || ''}`}
                                >
                                    {count}{' '}
                                    {appContext.geti18n(
                                        cfg?.label ||
                                            `requests.status.${status}`
                                    )}
                                </Badge>
                            )
                        })}
                    </div>
                </div>

                <div className="flex items-center gap-1.5 shrink-0">
                    <span className="coach-stat-value text-lg font-bold text-foreground leading-none">
                        {active.length}
                    </span>
                    <ChevronRight className="h-4 w-4 text-muted-foreground" />
                </div>
            </div>
        </LinkWithState>
    )
}

export default UserRequests
